export const FiltersConfig = {
    "default": {
        isHierarchyFilterEnabled: false,
        isUniversalFilterenabled: false,
        isHuddleFilterEnabled: false,
    },
    'account': {
        'home': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'scores': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: true,
            isHuddleFilterEnabled: false,
        },
        'inbox': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: true,
            isHuddleFilterEnabled: false,
        },
        'engagement': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'relationship':{
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        }
    },
    'project': {
        'scores': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: true,
            isHuddleFilterEnabled: false,
            'quickinsights': {
                isHierarchyFilterEnabled: false,
                isUniversalFilterenabled: false,
                isHuddleFilterEnabled: false,
            }
        },
        'inbox': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: true,
            isHuddleFilterEnabled: false,
        },
        'outbox':{
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'action': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: true,
            isHuddleFilterEnabled: false,
        },
        'engagement': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'huddle': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
            'all-suggestions': {
                isHierarchyFilterEnabled: true,
                isUniversalFilterenabled: false,
                isHuddleFilterEnabled: true,
            }
        },
        'sent': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'settings': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'user-access': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'configure-dashboard': {
            isHierarchyFilterEnabled: false,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        },
        'sentiment-analysis': {
            isHierarchyFilterEnabled: true,
            isUniversalFilterenabled: false,
            isHuddleFilterEnabled: false,
        }
    }
}